<template>
  <div class="row_box">
    <img
      v-if="String(item.payState) === '3'"
      alt="已退款"
      class="treatBoxImg"
      src="@funcPuzzle/mini_patient/refunded_status.png"
    />
    <img
      v-else-if="whenTheWormTwo(item) && item.payState !== '1'"
      class="treatBoxImg"
      src="@funcPuzzle/mini_patient/loseEfficacy.png"
    />
    <div class="row">
      <span class="name"> {{ item.itemName }}（{{ item.amount }}{{ item.itemUnix }}） </span>
      <span class="state">
        {{ getKeyValueText('pay_state', item.payState) || '--' }}
      </span>
    </div>
    <div class="row" v-if="item.prescripOrderType === '2'">
      <span class="title">样本类型：</span>
      <span class="content">
        {{ getKeyValueText('sample_type', item.sampleType) || '--' }}
      </span>
    </div>
    <div class="row" v-else>
      <span class="title">
        {{ getKeyValueText('item_type', item.prescripOrderType) + '部位：' }}
      </span>
      <span class="content">
        {{ getKeyValueText('body_parts', item.bodyPart) || '--' }}
      </span>
    </div>

    <div class="row">
      <span class="title">执行科室：</span>
      <span class="title">{{ item.exeDeptName }}</span>
    </div>
    <div class="row">
      <span class="title">开立时间：</span>
      <span class="title">{{ item.createTime }}</span>
    </div>

    <div class="row">
      <span class="title">项目单价：</span>
      <span class="price">￥{{ item.price }}</span>
    </div>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import dayjs from 'dayjs'

export default {
  props: {
    item: {
      type: Object || Array,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    // 判断失效时间是否小于当前时间，过期/已失效
    whenTheWormTwo(val) {
      return val => {
        let clankTwo
        if (!val || !val.outOfDateTime) {
          clankTwo = false
        } else {
          clankTwo = dayjs(val.outOfDateTime).isBefore(dayjs())
        }
        return clankTwo
      }
    }
  },
  methods: {
    getKeyValueText
  }
}
</script>

<style lang="scss" scoped>
.row_box {
  padding: 20px 32px;
  position: relative;
  border-bottom: 1px solid #ececec;
  .treatBoxImg {
    position: absolute;
    top: 32px;
    right: 32px;
    width: 118px;
    height: 96px;
  }
  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 28px;
    .name {
      font-size: 32px;
      font-weight: 500;
      color: #222222;
    }
    .title {
      font-size: 30px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
    .state {
      font-size: 30px;
      font-weight: 400;
      color: #0089ff;
    }
    .content {
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .price {
      font-size: 30px;
      font-weight: 500;
      color: #ff7555;
    }
  }
}
</style>
